import CreatePointSession from "@/domains/lines/views/geo/CreatePointSession"
import CreateRegularLine from "@/domains/lines/views/regularLines/CreateRegularLine.vue"
import UpdateRegularLine from "@/domains/lines/views/regularLines/UpdateRegularLine.vue"
import ListLines from "@/domains/lines/views/search/ListLines"
// import EditSchedule from "@/domains/lines/views/schedules/EditSchedule";
import SearchLines from "@/domains/lines/views/search/SearchLines"
import CreateSeasonality from "@/domains/lines/views/seasonalities/CreateSeasonality.vue"
import EditSeasonality from "@/domains/lines/views/seasonalities/EditSeasonality.vue"
import Seasonalities from "@/domains/lines/views/seasonalities/Seasonalities.vue"
import CreateSectionPoint from "@/domains/lines/views/sectionPoints/CreateSectionPoint.vue"
import EditSectionPoint from "@/domains/lines/views/sectionPoints/EditSectionPoint.vue"
import SectionPoints from "@/domains/lines/views/sectionPoints/SectionPoints.vue"
import CreateService from "@/domains/lines/views/services/CreateService.vue"
import Services from "@/domains/lines/views/services/Services"
import CreateTariffCoefficient from "@/domains/lines/views/tariffCoefficient/CreateTariffCoefficient.vue"
import TariffCoefficient from "@/domains/lines/views/tariffCoefficient/TariffCoefficient.vue"
import ViewTariffCoefficient from "@/domains/lines/views/tariffCoefficient/ViewTariffCoefficient.vue"
import Index from "./views/Index"
import IndexRegularLine from "./views/regularLines/IndexRegularLine.vue"

export default [
  {
    path: "/linhas",
    name: "lines.index",
    component: Index,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/linhas-regulares/",
    name: "lines.regular.index",
    component: IndexRegularLine,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/linhas-regulares/criar",
    name: "lines.regular.create",
    component: CreateRegularLine,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/linhas-regulares/:id/editar",
    name: "lines.regular.edit",
    component: UpdateRegularLine,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/sessoes",
    name: "lines.sessions",
    component: () =>
      import(/* webpackChunkName: "chunk-lines" */ "./views/geo/Sessions.vue"),
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/sessoes/criar",
    name: "lines.sessions.create",
    component: () =>
      import(
        /* webpackChunkName: "chunk-lines" */ "./views/geo/CreatePointSession.vue"
      ),
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/sessões/:id",
    name: "lines.sessions.edit",
    component: CreatePointSession,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  // {
  //     path: "/linhas/horarios",
  //     name: "lines.schedules",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "chunk-lines" */ "./views/schedules/Schedules.vue"
  //         ),
  //     meta: {
  //         forAuth: true,
  //         module: "lines"
  //     }
  // },
  // {
  //     path: "/linhas/horarios/criar",
  //     name: "lines.schedules.create",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "chunk-lines" */ "./views/schedules/EditSchedule.vue"
  //         ),
  //     meta: {
  //         forAuth: true,
  //         module: "lines"
  //     }
  // },
  // {
  //     path: "/linhas/horarios/:id",
  //     name: "lines.schedules.edit",
  //     component: EditSchedule,
  //     props: true,
  //     meta: {
  //         forAuth: true,
  //         module: "lines"
  //     }
  // },
  // {
  //     path: "/linhas/horarios/:id",
  //     name: "manager.lines.show",
  //     component: EditSchedule,
  //     props: true,
  //     meta: {
  //         forAuth: true,
  //         module: "lines"
  //     }
  // },
  {
    path: "/linhas/consulta",
    name: "lines.search.search",
    component: SearchLines,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/horarios",
    name: "lines.search.public",
    component: SearchLines,
    props: true,
    meta: {
      hideSidebar: true,
      forAuth: false,
      module: "lines",
    },
  },
  {
    path: "/linhas/consulta/:origin/:destiny",
    name: "lines.search.list",
    component: ListLines,
    props: true,
    meta: {
      forAuth: false,
      module: "lines",
    },
  },
  {
    path: "/linhas/coeficiente-tarifario",
    name: "lines.tariffCoefficient",
    component: TariffCoefficient,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/coeficiente-tarifario/:id(\\d+)",
    name: "lines.tariffCoefficient.view",
    component: ViewTariffCoefficient,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/coeficiente-tarifario/criar",
    name: "lines.tariffCoefficient.create",
    component: CreateTariffCoefficient,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/servicos",
    name: "lines.services",
    component: Services,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/servicos/criar",
    name: "lines.services.create",
    component: CreateService,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/sazonalidades",
    name: "lines.seasonalities",
    component: Seasonalities,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/sazonalidades/criar",
    name: "lines.seasonalities.create",
    component: CreateSeasonality,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/sazonalidades/:id/editar",
    name: "lines.seasonalities.edit",
    component: EditSeasonality,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/pontos-secao",
    name: "lines.sectionpoints",
    component: SectionPoints,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/pontos-secao/criar",
    name: "lines.sectionpoints.create",
    component: CreateSectionPoint,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
  {
    path: "/linhas/pontos-secao/:id/editar",
    name: "lines.sectionpoints.edit",
    component: EditSectionPoint,
    props: true,
    meta: {
      forAuth: true,
      module: "lines",
    },
  },
]
